import React, { Component } from 'react'
import interact from 'interact.js'
import InlineSVG from 'react-inlinesvg'
import _each from 'lodash/each'
import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _padStart from 'lodash/padStart'
import _shuffle from 'lodash/shuffle'
import _omit from 'lodash/omit'

import './css/Game.css'
import hypeLine from './images/hype-line.svg'
import arrow from './images/arrow.svg'
import loader from './images/ellipse.svg'
import SubmitForm from './SubmitForm'

class Game extends Component {

  constructor(props){
    super(props)

    let dots = [
      { title: 'Virtual Reality', correctTarget: 40 },
      { title: 'Augmented Reality', correctTarget: 30 },
      { title: 'Natural Language Q&A', correctTarget: 23 },
      { title: 'Connected Homes', correctTarget: 17 },
      { title: 'Block Chain', correctTarget: 14 },
      { title: 'Affective Computing', correctTarget: 10 },
      { title: 'Personal Analytics', correctTarget: 8 },
      { title: 'Quantum Computing', correctTarget: 6 },
      { title: '4D Printing', correctTarget: 4 },
      { title: 'Smart Dust', correctTarget: 2 },
    ]

    this.state = {
      scoreTotal: 0,
      snapTargets: [],
      scores: {},
      submitFormDisplay: false,
      dots: _shuffle(dots),
      loading: false
    }
  }

  dragMoveListener(event){
    _each(document.querySelectorAll('.dot'), dot => {
      dot.classList.remove('active')
    })
    event.target.classList.add('active')
    const target = event.target
    // keep the dragged position in the data-x/data-y attributes
    let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
    let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

    // translate the element
    target.style.webkitTransform =
    target.style.transform =
      'translate(' + x + 'px, ' + y + 'px)'

    // update the posiion attributes
    target.setAttribute('data-x', x)
    target.setAttribute('data-y', y)
  }

  calculateSnapTargets(){
    let snapTargets = []

    const targets = document.querySelectorAll('[id^="targets"] g[id^="target"]')
    _each(targets, target => {
      const bounds = target.getBoundingClientRect()
      // get the target number from the svg ID
      const targetID = parseInt(target.getAttribute('id').split('-')[1].substr(0, 2), 10)
      snapTargets.push({
        x: bounds.left + (bounds.width / 2),
        y: bounds.top + (bounds.height / 2),
        range: 100,
        id: targetID
      })
    })

    this.setState({ snapTargets: snapTargets })

  }

  componentDidUpdate(){
    this.interactInit()
  }

  interactInit(){
    interact('.draggable')
      .draggable({
        snap: {
          targets: this.state.snapTargets || [],
          endOnly: true,
          relativePoints: [
            { x: 0.5  , y: 0.5   },
          ]
        },
        inertia: true,
        // autoScroll: true,
        restrict: {
          restriction: '.GameWrap',
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        onmove: this.dragMoveListener,
        onend: event => {
          this.calculateScore(event)
        },
      })
  }

  calculateScore(snapEvent){
    let snapX = snapEvent.clientX
    let snapY = snapEvent.clientY
    const nearestTargets = _filter(this.state.snapTargets, target => {
      // calculate position difference between snap and target
      let distX = Math.abs(snapX - target.x)
      let distY = Math.abs(snapY - target.y)
      return distX < 20 && distY < 20
    })
    const nearestTarget = nearestTargets.length ? nearestTargets[0] : null
    const correctTarget = parseInt(snapEvent.target.getAttribute('data-correct-target'), 10)

    const stateObj = _find(this.state.dots, dot => {
      return dot.title === snapEvent.target.getAttribute('data-id')
    })

    if(stateObj){
      if(nearestTarget){

        let score = 10 - Math.abs(correctTarget - nearestTarget.id)
        if(score < 0) score = 0
        let scoresObj = this.state.scores
        scoresObj[stateObj.title] = score
        this.setState({scores: scoresObj})
        let totalScore = 0
        _each(this.state.scores, score => {
          totalScore += score
        })
        this.setState({ scoreTotal: totalScore })

      } else {

        // Remove current snapped dot from scores
        let filteredScores = _omit(this.state.scores, stateObj.title)
        this.setState({
          scores: filteredScores
        })

      }
    }
  }

  submitScore(data){
    console.log('Submitting score')
    this.props.addScore(data)
    this.showHideForm()
  }

  renderDots(){
    return this.state.dots.map(dot => {
      const snapped = Object.keys(this.state.scores).find(score => score === dot.title) ? true : false
      let snappedClass = snapped ? 'snapped' : ''
      return <div key={dot.title} className={`dot draggable ${snappedClass}`} data-id={dot.title} data-correct-target={dot.correctTarget}>{dot.title}</div>
    })
  }

  renderCorrectDots(){

    return this.state.dots.map(dot => {
      const myTarget = _find(this.state.snapTargets, target => target.id === dot.correctTarget)
      if(!myTarget) return false
      const style = {
        left: myTarget.x,
        top: myTarget.y
      }
      return <div style={style} key={dot.title} className={`dot correct`} data-id={dot.title} data-correct-target={dot.correctTarget}>{dot.title}</div>
    })
  }

  renderSubmitForm(){
    if(this.state.submitFormDisplay) return <SubmitForm score={this.state.scoreTotal} submitScore={this.submitScore.bind(this)} hideForm={this.showHideForm.bind(this)}/>
  }

  showHideForm(event){
    if(event) event.preventDefault()
    if(this.state.submitFormDisplay){
      this.props.changeScreen('Scores')
    }
    this.setState({submitFormDisplay: !this.state.submitFormDisplay})
  }

  renderSubmitButton(){
    // check if all dots have snapped to a score
    const handleClick = e => {
      e.preventDefault()
      this.setState({loading: true})
      document.querySelector('.Game').classList.add('displayCorrect')
      setTimeout(() => {
        this.showHideForm()
      }, 7000)
    }
    if(Object.keys(this.state.scores).length === Object.keys(this.state.dots).length && !this.state.loading){
      return <a className="bigButton" onClick={(event) => handleClick(event)}>Submit <InlineSVG src={arrow} /></a>
    } else if(this.state.loading){
      return <div><InlineSVG className="SubmitLoading" src={loader} /></div>
    }
  }

  render(){
    return (
      <div className="Game">
        <div className="GameWrap animated fadeIn">
          <div className="score">Score = <strong>{this.state.scoreTotal}</strong></div>
          <InlineSVG className="hypeLine" src={hypeLine} onLoad={this.calculateSnapTargets.bind(this)} />
          { this.renderCorrectDots() }
          <div className="dotContainer">
            { this.renderDots() }
          </div>
        </div>
        <div className="GameFooter animated fadeIn">
          { this.renderSubmitButton() }
        </div>
        { this.renderSubmitForm() }
      </div>
    )
  }
}

export default Game



/** WEBPACK FOOTER **
 ** ./src/Game.js
 **/